/**
 * @param {Event} e - The keydown event.
 * @param {number} index - The index of the currently focused search result.
 * @param {Array} searchResults - The array of search results.
 */
export const handleResultKeyDown = (e, index, searchResults) => {
    const employerField = document.getElementById("Employer");
    const cancelButton = document.getElementById("search-results-cancel");

    if (!searchResults) {
        employerField?.setAttribute("aria-expanded", "false");
        return;
    }

    const focusElement = (id) => {
        const element = document.getElementById(id);
        element?.focus();
        return element;
    };

    const setAriaSelected = (id, selected) => {
        document.getElementById(id)?.setAttribute("aria-selected", selected);
    };

    const setAriaActiveDescendant = (id) => {
        employerField?.setAttribute("aria-activedescendant", id);
    };

    switch (e.key) {
        case "Enter":
        case " ":
            e.target.click();
            break;
        case "Escape":
            employerField?.focus();
            break;
        case "ArrowDown":
            if (Number(index) < searchResults.length - 1) {
                const nextIndex = Number(index) + 1;
                const nextElementId = `gift-matching__result-${nextIndex}`;
                const currentElementId = `gift-matching__result-${index}`;
                setAriaSelected(currentElementId, "false");
                focusElement(nextElementId);
                setAriaSelected(nextElementId, "true");
                setAriaActiveDescendant(nextElementId);
            } else if (Number(index) === searchResults.length - 1) {
                cancelButton?.focus();
            } else if (e.target.id === "search-results-cancel") {
                focusElement(`gift-matching__result-0`);
            }
            break;
        case "ArrowUp":
            if (Number(index) > 0) {
                const prevIndex = Number(index) - 1;
                const prevElementId = `gift-matching__result-${prevIndex}`;
                const currentElementId = `gift-matching__result-${index}`;
                setAriaSelected(currentElementId, "false");
                focusElement(prevElementId);
                setAriaSelected(prevElementId, "true");
                setAriaActiveDescendant(prevElementId);
            } else if (Number(index) === 0) {
                cancelButton?.focus();
            } else if (e.target.id === "search-results-cancel") {
                const lastElementId = `gift-matching__result-${searchResults.length - 1}`;
                focusElement(lastElementId);
            }
            break;
        default:
            break;
    }
};
